// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"6f993b6e","453":"88144670","456":"b22ab5ce","961":"423b442b"}[chunkId] + ".chunk.js";
};